import React, { Component, Fragment } from 'react';

import './TextClamp.css';

export default class TextClamp extends Component {
  state = { showFullText: false };

  render() {
    const { showFullText } = this.state;
    return (
      <Fragment>
        <this.ChildTag className={this.getClassName(showFullText)}>
          {this.completeText}
        </this.ChildTag>
        {this.renderReadMoreBtn(showFullText)}
      </Fragment>
    );
  }

  ChildTag = this.props.children.type;

  childClassName = this.props.children.props.className;

  completeText = this.props.children.props.children;

  textExceedsCharLimit = this.completeText.length < 180;

  getClassName = showFullText => {
    if (showFullText || this.textExceedsCharLimit) return this.childClassName;

    return `${this.childClassName} text-clamp`;
  };

  renderReadMoreBtn = showFullText => {
    if (this.textExceedsCharLimit) return null;

    const handleClick = showFullText ? this.onSeeLess : this.onReadMore;
    const btnText = showFullText ? 'See Less' : 'Read More';

    return (
      <span onClick={handleClick} className="read-more-comment">
        {btnText}
      </span>
    );
  };

  onReadMore = () => this.setState({ showFullText: true });

  onSeeLess = () => this.setState({ showFullText: false });
}



// WEBPACK FOOTER //
// ./src/components/TextClamp/TextClamp.jsx